module.exports = __webpack_public_path__ + "img/Drohne_Bild.2ac473ac.jpg";